import './PrivacyPolicy.css';
import mrlogo from './images/M_R-White.png';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
function Footer() {
  return (
    <div class="privacy">
        <p>Last updated: October 18th, 2022</p>

        <h1>Music Server Charts Privacy Policy</h1>
        <p>"We", "Us", "Our" in this policy refers to us, the team behind Music Server Charts and not any other services or websites linked in our services.</p>
        <p>"Service", "Services" refers to all services provided by us, including but not limited to the Music Server Charts Website and the Music Server Charts bot application.</p>
        <p>"Agreement" collectively refers to our <Link to="/tos">Terms</Link> and <Link to="/privacy">Privacy Policy</Link>.</p>
        <p>By accessing, browsing or using our services, you agree to allow us to store information we need to provide the services to you as mentioned in this agreement.</p>
        
        <h2>1. Data We Collect</h2>

        <h3>User Data</h3>
        <p>Music Server Charts collects from individual Discord users the following data: A unique identifable ID, their Discord username, discriminator and their Discord avatar hash.
          Furthermore we will also collect neccessary Authorization tokens, once granted by the User, in order to connect with the neccessary Discord and Spotify APIs.
          Music Server Charts also collects Presence Data emitted from Users, which contains the names of the artists, the track itself, and the album that the track belongs to, aswell as a unique identifiying ID, a timestamp and the amount of seconds that a track was played for.</p>

        <h3>Server Data</h3>
        <p>Music Server Charts collects from Discord servers the following data: A unique identifable ID, the name of the server and their avatar hash.</p>
        <h3></h3>

        <h2>2. What we do with your Data</h2>
        <p>We do not and will not share any information collected with any third parties unless legally obliged to.</p>

        <h2>3. Data Retention</h2>
        <p>All data collected will be retained for as long as we need it to serve the purpose we collected it for. If you wish to have your data removed you may contact us via the provided links in the “Contact” section of this policy below.</p>

        <h2>4. Updates to this Policy</h2>
        <p>We may update this policy from time to time. The updated version will be indicated by an updated Revised date and available on this page.</p>

        <h2>5. Contact</h2>
        <p>If you have any questions about this notice, you may contact us in by any of the following:<br />
        E-Mail: <a href="mailto:msc@marcorennmaus.de">msc@marcorennmaus.de</a><br />
        Discord: <a href="https://discord.gg/WZbXEMF">https://discord.gg/WZbXEMF</a></p>

    </div>
  );
}

export default Footer;
